export default __webpack_public_path__ + "static/media/close-dark.d1d65821.svg";